module.exports = __webpack_public_path__ + "static/media/icon-download.490382d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-download.svg
// module id = 2399
// module chunks = 0